import { render, staticRenderFns } from "./CreativeDetail.vue?vue&type=template&id=25880788&scoped=true"
import script from "./CreativeDetail.vue?vue&type=script&lang=js"
export * from "./CreativeDetail.vue?vue&type=script&lang=js"
import style0 from "./CreativeDetail.vue?vue&type=style&index=0&id=25880788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25880788",
  null
  
)

export default component.exports